import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  header: {
    defaultMessage: 'Which type of menu do you want?',
  },
});
